export const cryptoKey = 'my-secret-key@123';
